import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { projects, projectFilters, IMG } from "../lib/data";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";

const Projects = () => {
  const { t, lang } = useLanguage();
  const [filter, setFilter] = useState("all");
  const list = filter === "all" ? projects : projects.filter((p) => p.category === filter);

  return (
    <div data-testid="projects-page">
      <PageHero label={t.projectsPage.label} title={t.projectsPage.heading} sub={t.projectsPage.sub} image={IMG.siteWork} />

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap gap-2.5 mb-10">
            {projectFilters.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`project-filter-${c}`}
                className={`px-4 py-2 text-sm font-medium border transition-all duration-200 ${
                  filter === c
                    ? "bg-[#D4AF37] border-[#D4AF37] text-[#0A1223]"
                    : "bg-transparent border-white/15 text-slate-300 hover:border-[#D4AF37]/60 hover:text-white"
                }`}
              >
                {t.projectsPage.filters[c]}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map((p, i) => (
              <motion.div
                key={p.id}
                layout
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
                className="group relative overflow-hidden border border-white/12"
                data-testid={`project-card-${p.id}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p[lang].title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1223] via-[#0A1223]/30 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-6">
                  <span className="inline-block text-xs font-mono text-[#D4AF37] mb-2 uppercase tracking-wider">
                    {t.projectsPage.filters[p.category]}
                  </span>
                  <h3 className="font-heading text-lg font-bold text-white leading-tight">{p[lang].title}</h3>
                  <p className="text-sm text-slate-300 mt-1">{p[lang].meta}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
};

export default Projects;
